import { ReportsProvider, ReportsService } from "@sportal/api/reports";
import { HttpService } from "@sportal/api";
import { AppConfig } from "./appConfigService.types";

export const makeReportsService = (
  http: HttpService,
  config: AppConfig
): ReportsService =>
  new ReportsService(
    new ReportsProvider(http, config.backendUrl, config.reportingTimeoutMinutes)
  );
